<template>
  <div class="creat-order">
    <a-spin :spinning="loading">
    <div class="top">
        <div class="info">提示：您正在填写订单信息，系统将会为您实时保存数据，填写完成后点击“提交”按钮即可完成下单。</div>
    </div>
    <div class="title">
        <span class="label">当前选择的实验室：</span><span class="text" v-if="formObj.labName">{{formObj.labName}}</span> 
        <a-button size="small" type="link" @click="selectLab"> 重新选择实验室<a-icon type="right" /></a-button>
    </div>
    <div class="select-type">
        <div :class="type == 2? 'type-list active': 'type-list'" @click="selectType(2)">
            <p><span>认证检测</span> <a-icon type="check-circle" /></p>
            <p>我已在认证机构填报过检测要求</p>
        </div>
        <div :class="type == 3? 'type-list active': 'type-list'" @click="selectType(3)">
            <p><span>商业检测（已委托）</span> <a-icon type="check-circle" /></p>
            <p>我已在实验室填报过检测要求</p>
        </div>
        <div :class="type == 1? 'type-list active': 'type-list'"  @click="selectType(1)">
            <p><span>商业检测（新申请）</span> <a-icon type="check-circle" /></p>
            <p>我有一个产品需要在线送检</p>
        </div>
    </div>
    <div v-if="type == 1" >
        <div class="til">委托单位</div>
            <div class="form-box">
                <div class="form-list">
                    <div class="name"> <i class="red">*</i> 公司名称：</div>
                    <div class="input-box">
                        <a-input v-model="formObj.companyName" placeholder="请输入公司名称" :maxLength="150" allowClear @blur="changeData('companyName', formObj.companyName)"/>
                    </div>
                </div>
                <div class="form-list">
                    <div class="name"> <i class="red">*</i> 公司地址：</div>
                    <div class="input-box">
                        <a-cascader
                        v-model="formObj.companyRegionCodeArray"
                        style="margin-right: 10px;width: 260px;"
                        :options="cascaderOptions" 
                        @change="regionOnChange" 
                        :showSearch="{filter}" 
                        placeholder="请选择省市县"
                    />
                        <a-input v-model="formObj.companyDetailAddress" placeholder="请输入详细地址信息" :maxLength="120" allowClear @blur="changeData('companyDetailAddress', formObj.companyDetailAddress)"/>
                    </div>
                    
                </div>
                <div class="form-list">
                    <div class="name"> <i class="red">*</i> 邮寄地址：</div>
                    <div class="input-box">
                        <a-cascader
                        v-model="formObj.mailingRegionCodeArray"
                        style="margin-right: 10px;width: 260px;"
                        :options="cascaderOptions"
                        @change="mailOnChange"
                        :showSearch="{filter}" 
                        placeholder="请选择省市县"
                    />
                        <a-input v-model="formObj.mailingDetailAddress" placeholder="请输入详细地址信息" :maxLength="120" allowClear @blur="changeData('mailingDetailAddress', formObj.mailingDetailAddress)"/>
                    </div>
                </div>
                <div class="form-list">
                    <div class="name"> <i class="red">*</i> 联系人/电话：</div>
                    <div class="input-box">
                        <a-input v-model="formObj.contactPerson" style="margin-right: 10px;" placeholder="请输入联系人姓名" :maxLength="50" allowClear @blur="changeData('contactPerson', formObj.contactPerson)"/>
                        <a-input v-model="formObj.contactPhone" placeholder="请输入联系人电话" :maxLength="20" allowClear @blur="changeData('contactPhone', formObj.contactPhone)"/>
                    </div> 
                </div>
                <div class="form-list">
                    <div class="name"> 其他联系方式：</div>
                    <div class="input-box">
                        <a-input v-model="formObj.qqNumber" style="margin-right: 10px;" placeholder="请输入QQ号码" :maxLength="20" allowClear @blur="changeData('qqNumber', formObj.qqNumber)"/>
                        <a-input v-model="formObj.wechatNumber" style="margin-right: 10px;" placeholder="请输入微信号" :maxLength="20" allowClear @blur="changeData('wechatNumber', formObj.wechatNumber)"/>
                        <a-input v-model="formObj.email" placeholder="请输入邮箱" :maxLength="40" allowClear @blur="changeData('email', formObj.email)"/>
                    </div>
                </div>
                <div class="btn-area">
                    <a-button style="margin-right: 15px" type="primary" @click="saveNewData">保存为新模板</a-button>
                    <a-button :disabled="!changeId" type="primary" @click="saveOldData">保存到当前选择模板</a-button>
                </div>
                <p style="margin: 15px 0"><a-icon type="tags" /> 选择模板 <span class="ts">（提示：模板管理为您提供委托单位模板维护，您可通过点击“保存为新模板”创建委托单位模板，在后续下单时可直接选用改模板，无需手动输入；也可通过选中模板进行委托单位模板信息修改，点击“保存”修改模板信息。）</span></p>
                <div class="table">
                    <a-table
                        :rowClassName="rowClassName"
                        :columns="columns"
                        :dataSource="dataList"
                        :pagination="false"
                        @expandRowByClick="true"
                        :rowKey="record => record.id"
                        :row-selection="rowSelection"
                        :scroll="{
                            y: 300
                        }"
                        :locale="{
                        emptyText: '暂无数据'
                        }">
                        <template slot="otherType"  slot-scope="record">
                            <p>QQ: {{record.qqNumber}}</p>
                            <p>微信：{{record.wechatNumber}}</p>
                            <p>邮箱：{{record.email}}</p>
                        </template>
                        <template slot="operation"  slot-scope="record">
                            <a-button :disabled="changeId == record.id" type="link" size="small" @click="delEntrustInfo(record.id)">删除</a-button>
                            <a-button :disabled="record.isDefault" type="link" size="small" @click="setDefaultInfo(record.id)">设为默认</a-button>
                        </template>
                    </a-table>
                </div>

            </div>
            <div class="til" style="margin-top: 50px">生产单位</div>
            <div class="box sample-info">
                <p>
                    <span class="name"> <i class="red">*</i> 制造商：</span>
                    <!-- <a-input v-model="formObj.manufacturerName" placeholder="制造商" :maxLength="150" allowClear @blur="changeData('manufacturerName', formObj.manufacturerName)"/> -->
                    <a-select
                    style="width: 100%"
                    show-search
                    allowClear
                    v-model="formObj.manufacturerName"
                    placeholder="请输入制造商名称"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="handleSearch"
                    @blur="blurChange"
                >
                    <a-select-option v-for="d in data" :key="d">
                    {{ d }}
                    </a-select-option>
                </a-select>
                </p>
                <p>
                    <span class="name"> <i class="red">*</i> 制造商地址：</span>
                    <a-input v-model="formObj.manufacturerAddress" placeholder="请输入制造商地址" :maxLength="150" allowClear @blur="changeData('manufacturerAddress', formObj.manufacturerAddress)"/>
                </p>
                <p>
                    <span class="name"> <i class="red">*</i> 生产商：</span>
                    <a-input v-model="formObj.factoryName" placeholder="请输入生产商名称" :maxLength="150" allowClear @blur="changeData('factoryName', formObj.factoryName)"/>
                </p>
                <p>
                    <span class="name"> <i class="red">*</i> 生产商地址：</span>
                    <a-input v-model="formObj.factoryAddress" placeholder="请输入生产商地址" :maxLength="150" allowClear @blur="changeData('factoryAddress', formObj.factoryAddress)"/>
                </p>
            </div>
            <div class="til">样品信息</div>
            <div class="box">
                <div class="sample-table">
                    <div class="sample-list" v-for="(i, index) in formObj.testSamples" :key="index">
                        <div class="left-box">
                            <div class="list">
                                <span class="name">样品名称：</span>
                                <a-input class="model" v-model="i.sampleName" :maxLength="120" placeholder="样品名称" allowClear @blur="changeSampleInfo(i.id, 'sampleName', i.sampleName)"/>
                            </div>
                            <div class="list">
                                <span class="name"> <i class="red">*</i> 检测要求：</span>
                                <a-textarea class="model" v-model="i.testingRequirements" :maxLength="120" :autoSize="{ minRows: 2, maxRows: 5 }" placeholder="检测要求" allowClear @blur="changeSampleInfo(i.id, 'testingRequirements', i.testingRequirements)"/>
                            </div>
                        </div>
                        <span class="del-icon">
                            <a-icon type="delete" style="font-size: 26px;cursor: pointer;" theme="outlined" @click="delListData(i.id)" />
                        </span>
                    </div>
                </div>
                <div style="margin: 15px 0;">
                    <a-button size="small" type="link" @click="addNewList()"><a-icon type="plus" />添加下一个</a-button>
                </div>
            </div>
            <div class="til">报告要求</div>
            <div class="box report-info">
                <p>
                    <span class="name"> <i class="red">*</i> 报告语言：</span>
                    <a-select v-model="formObj.reportLanguage" style="width: 60%" @change="changeData('reportLanguage', formObj.reportLanguage)">
                        <a-select-option value="0">中文报告</a-select-option>
                        <a-select-option value="1">英文报告</a-select-option>
                        <a-select-option value="2">中英文对照报告</a-select-option>
                    </a-select>
                </p>
                <p>
                    <span class="name"> <i class="red">*</i> 报告交付方式：</span>
                    <a-select v-model="formObj.deliveryType" style="width: 60%" @change="changeData('deliveryType', formObj.deliveryType)">
                        <a-select-option value="0">电子版</a-select-option>
                        <a-select-option value="1">纸质版</a-select-option>
                    </a-select>        
                </p>
                <p>
                    <span class="name"> <i class="red">*</i> 报告份数：</span>
                    <a-input-number v-model="formObj.reportNum" style="width: 60%" type="number" :max="99" :min="1" placeholder="报告份数" allowClear @blur="changeData('reportNum', formObj.reportNum)"/>
                </p>
                <p>
                    <span class="name"> <i class="red">*</i> 是否加急：</span>
                    <a-select v-model="formObj.deadlineType" style="width: 60%" @change="changeData('deadlineType', formObj.deadlineType)">
                        <a-select-option value="0">不加急</a-select-option>
                        <a-select-option value="1">加急</a-select-option>
                    </a-select> 
                </p>
                <p>
                    <span class="name"> <i class="red">*</i> 希望完成日期：</span>
                    <a-date-picker style="width: 60%" :disabledDate="disabledDate" v-model="formObj.expectTime" @change="changeData('expectTime', formObj.expectTime)" />
                </p>
            </div>
            <div class="remark-box">
                <span class="name">备注：</span>
                <a-textarea style="width: 80%" v-model="formObj.remark" placeholder="请输入备注" :autoSize="{ minRows: 2, maxRows: 8 }" @blur="changeData('remark', formObj.remark)" />
            </div>
    </div>
    <div v-else>
        <div class="til">{{type == 2 ? '认证申请信息' : '委托申请信息'}}</div>
        <div class="inline-form">
            <span class="label"> <i class="red">*</i>  委托单位名称：</span>
            <a-input v-model="formObj.companyName" placeholder="请填写拟写入检测报告的委托方名称" allowClear @blur="changeData('companyName', formObj.companyName)"/>
        </div>
        <div class="inline-form" v-if="type == 2">
            <span class="label"> <i class="red">*</i>  认证申请编号：</span>
            <a-input v-model="formObj.applyNumber" placeholder="请填写认证申请编号" allowClear @blur="changeData('applyNumber', formObj.applyNumber)"/>
        </div>
        <div class="inline-form" v-else>
            <span class="label"> <i class="red">*</i>  委托申请编号：</span>
            <a-input v-model="formObj.orderNumber" placeholder="请填写委托申请编号" allowClear @blur="changeData('orderNumber', formObj.orderNumber)"/>
        </div>
        <div class="inline-form">
            <span class="label"> <i class="red">*</i> 希望完成日期：</span>
            <a-date-picker :disabledDate="disabledDate" placeholder="请选择希望完成时间" v-model="formObj.expectTime" @change="changeData('expectTime', formObj.expectTime)" />
        </div>
        <div class="inline-form">
            <span class="label"> 产品名称：</span>
            <a-input v-model="formObj.productName" placeholder="请填写产品名称" allowClear @blur="changeData('productName', formObj.productName)"/>
        </div>
        <div class="inline-form inline-form_max">
            <span class="label" style="vertical-align: top;">备注：</span>
            <a-textarea v-model="formObj.remark" placeholder="请填写备注" :autoSize="{ minRows: 2, maxRows: 8 }" @blur="changeData('remark', formObj.remark)" />
        </div>
        <div class="inline-form inline-form_max">
            <span class="label" style="vertical-align: top;">{{type == 2 ? '认证申请附件' : '委托申请附件'}}：</span>
            <div class="upload-box">
                <!-- jpg、png、img、excel、word、pdf -->
                <a-upload
                    accept=".doc,.docx,.pdf,.PDF,.jpg,.png,.xls"
                    name="file"
                    :multiple="true"
                    :action="doUpload"
                    :showUploadList="false"
                    :headers="headers"
                    :beforeUpload="beforeAvatarUpload"
                    @change="headerChange"
                >
                    <a-button> <a-icon type="upload" />上传附件（20M以内）</a-button>
                </a-upload>
                <div class="file-list" v-for="(s, index) in photoList" :key="index">
                    <div class="file">
                        <span class="file-name" @click="preview(s.inlineUrl)"><a-icon type="file" /> {{s.fileName}}</span>
                        <a-icon class="file-delete-btn" type="delete" @click="delHeaderAction(s.id)"/>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <div class="btn-box">
        <a-button style="margin-right: 20px" @click="goBack">返回</a-button>
        <a-button type="primary" @click="submitForm">提交</a-button>
    </div>
    </a-spin>
  </div>
</template>

<script>
import { getEnterpriseDetail, getEntrustInfoList, getOneEntrustInfo, changeData, newCreatEntrustInfo, changeEntrustInfo,
 addNewSampleInfo, changeSampleInfo, delSampleInfo, delEntrustInfo, setDefaultInfo, submitForm, getManufacturerList,
 getManufacturerName, addNewAnnex, deleteAnnex, deleteEntrustForm } from '@/api/entrust'
import moment from 'moment';
import {formatDate} from '@/utils/date';
import { getToken, setselectNearest } from "@/utils/auth";


const align = 'center'
export default {
  components: {},
  data() {
    return {
        formId: '',
        cascaderOptions: [],
        type: 2,
        doUpload: "/api/ossPrivateConfig", //上传文件api
        headers: {},
        previewImage: '',
        photoList: [],
        formObj: {
            manufacturerName: '',
            productName: '', // 产品名称
            // paymentCompany: '', //缴费单位
            companyName: '', // 委托单位
        },
        columns:[
        {
          title: "公司名称",
          dataIndex: 'companyName',
          align,
          width: 200
        },
        {
          title: "公司地址",
          dataIndex: 'companyAddress',
          align,
          width: 200
        },
        {
          title: "邮寄地址",
          dataIndex: 'mailingAddress',
          align,
          width: 200
        },
        {
          title: "联系人",
          dataIndex: 'contactPerson',
          align,
          width: 200
        },
        {
          title: "电话",
          dataIndex: 'contactPhone',
          align,
          width: 200
        },
        {
          title: "其他联系方式",
          scopedSlots: { customRender: 'otherType' },
          align,
          width: 200
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          align,
          width: 150,
        }
      ],
      testSamples: [
        {
          title: "序号",
          dataIndex: 'no',
          align,
          width: 60
        },
        {
          title: "样品名称",
          scopedSlots: { customRender: 'sampleName' },
          align,
          width: 200
        },
        {
          title: "样品数量",
          scopedSlots: { customRender: 'sampleNum' },
          align,
          width: 80
        },
        {
          title: "检测要求",
          scopedSlots: { customRender: 'testingRequirements' },
          align,
          width: 200
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' },
          align,
          width: 150,
        }
      ],
      dataList: [],
      changeId: null,
      manufacturerList: [],
      data: [],
      loading: true,
      needDel: true, // 是否需要删除数据
    };
  },
  computed: {
    rowSelection() {
      return {
        type: "radio", //单选按钮定义
        onChange: (selectedRowKeys, selectedRows) => {
          this.changeId = selectedRowKeys[0];
          let params = {
              'entrustedId': selectedRowKeys[0],
              'id': this.formId
          }
          this.getOneEntrustInfo(params);
         }
      };
    }
  },
  created() {
    let query = this.$route.query;
    this.cascaderOptions = this.$region;
    if (query.id) {
        this.formId = query.id;
        this.getEnterpriseDetail(this.formId);
        this.getEntrustInfoList();
        this.getManufacturerList();
    }
    if (query.type) {
        this.type = query.type;
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
        let that = this;
        if (that.needDel) {
            let sing = confirm('您尚未提交订单信息，是否删除该订单？');
            if (sing) {
                // 直接离开页面的话，要删除草稿
                deleteEntrustForm(that.formId)
                .then(res => {
                    that.$bus.$emit('ifReload');
                })
                .catch(error => {
                    console.log(error);
                })
            }
        }
  },
  methods: {
    init() {
      let token = getToken();
      this.headers.Authorization = "Bearer " + token; //上传文件绑定Token  ie10以下不能使用
    },
    // 预览附件
    preview(url){
        if (url && url[0] === '/') {
            window.open(window.location.origin + url);
        } else {
            window.open(url);
        }
    },
    selectType(type) {
        this.type = type;
        this.changeData('type', this.type);
    },
    beforeAvatarUpload(file) {
        this.count = 0;
        const isLt2M = file.size / 1024 / 1024 < 20;
        if(!isLt2M) {  
        this.$message.error('上传文件大小不能超过20MB!');
        }  return isLt2M
    },
    addNewAnnex(id, fileId) {
        let params = { id, fileId };
        addNewAnnex(params)
        .then(res => {
            this.photoList = res;
        })
        .catch(error => {
            console.log(error);
        })
    },
    headerChange(data) {
        if (data.file.status == "done") {
            let fileId = data.file.response.id;
            this.addNewAnnex(this.formId, fileId);
            this.$message.success("文件上传成功");
        } else if (data.file.status == "error") {
            this.$message.error("文件上失败，请重新上传！");
        }
    },
    delHeaderAction(photoId) {
        let that = this;
        that.$confirm({
            title: '确定删除该附件吗',
            okText: '确认',
            cancelText: '取消',
            onOk:function () {
                that.deleteAnnex(that.formId, photoId);
            },
        })

    },
    deleteAnnex(id, fileId) {
        let params = { id, fileId };
        deleteAnnex(params)
            .then(res => {
                this.photoList = res;
            })
            .catch(error => {
                console.log(error);
            })
    },
    disabledDate(current) {
        return current < moment().subtract(1, 'day')
    },
    rowClassName(record) {
        if (record.isDefault) {
            return 'color-bg';
        }
    },
    handleSearch(value) {
      let list = this.manufacturerList;
      let data = [];
      if (value && list.length > 0) {
        list.map(i => {
            if (i.indexOf(value) != -1) {
                data.push(i);
            }
        })
      } else {
        data = [];
      }
      this.formObj.manufacturerName = value;
      this.data = data;
    },
    blurChange(e) {
        this.formObj.manufacturerName = e;
        this.changeData('manufacturerName', this.formObj.manufacturerName)
        this.handleChange(e);
    },
    handleChange(value) {
        this.formObj.manufacturerName = value;
        if (value) {
            let params = {
                'id': this.formId,
                'name': value
            }
            getManufacturerName(params)
                .then(res => {
                    this.formObj.factoryAddress = res.factoryAddress;
                    this.formObj.factoryName = res.factoryName;
                    this.formObj.manufacturerAddress = res.manufacturerAddress;
                })
                .catch(error => {
                    console.log(error);
                })
        }
    },
    goBack() {
        let that = this;
        that.$confirm({
            title: '您尚未提交订单信息，返回后数据将被删除，是否继续退出？',
            okText: '是',
            cancelText: '否',
            onOk:function () {
                deleteEntrustForm(that.formId)
                .then(res => {
                    that.needDel = false;
                    that.$bus.$emit('ifReload');
                    that.$router.push({path: '/detection/orderManage'});
                })
                .catch(error => {
                    console.log(error);
                })
            },
        })
    },
    selectLab() {
        if (this.formId) {
            this.needDel = false;
            this.$router.push({path: '/detection/selectLaboratory', query: {'formId': this.formId}});
        }
    },
    filter(inputValue, path) {
      return path.some(
        option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
      );
    },
    // 添加下一个
    addNewList() {
        this.addNewSampleInfo();
    },
    // 删除样品信息
    delListData(id) {
        delSampleInfo(id)
            .then(res => {
                this.getEnterpriseDetail(this.formId);
            })
            .catch(error => {
                console.log(error);
            })
    },
    // 删除委托单
    delEntrustInfo(id) {
        let that = this;
        that.$confirm({
            title: '是否确认删除该模板？',
            okText: '确定',
            cancelText: '取消',
            onOk:function () {
                delEntrustInfo(id)
                    .then(res => {
                        that.getEntrustInfoList();
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
        })
        
    },
    // 设为默认
    setDefaultInfo(id) {
        setDefaultInfo(id)
            .then(res => {
                this.getEntrustInfoList();
            })
            .catch(error => {
                console.log(error);
            })
    },
    // 添加新的样品信息
    addNewSampleInfo() {
        let params = {
            'orderId': this.formId
        }
        addNewSampleInfo(params)
            .then(res => {
                this.getEnterpriseDetail(this.formId);
            })
            .catch(error => {
                console.log(error);
            })
    },
    regionOnChange(value, selectedOptions){
        this.changeData('companyRegionCode', value.join(','));
    },
    getManufacturerList() {
        getManufacturerList()
            .then(res => {
                this.manufacturerList = res;
            })
            .catch(error => {
                console.log(error);
            })
    },
    mailOnChange(value) {
        this.changeData('mailingRegionCode', value.join(','));
    },
    changeData(key, value) {
        if (key == 'expectTime') {
            value = Date.parse(formatDate(new Date(value._d),"yyyy-MM-dd"));
        }
        if (key === 'reportNum' && !this.formObj.reportNum) {
            this.$message.warning('报告份数不能少于 1 份！');
            this.formObj.reportNum = 1;
            return;
        }
        let params = {
            'id': this.formId,
            'key': key,
            'value': value
        }
        changeData(params)
            .then(res => {
            })
            .catch(error => {
                console.log(error);
            })
    },
    changeSampleInfo(id, key, value) {
        let params = {
            'id': id,
            'key': key,
            'value': value
        }
        changeSampleInfo(params)
            .then(res => {
            })
            .catch(error => {
                console.log(error);
            })
    },
    //保存为新模板
    saveNewData() {
        if (!this.formObj.companyName) {
            this.$message.error('请先填写公司名称');
            return false;
        }
        if (this.formObj.companyRegionCodeArray.length < 1) {
            this.$message.error('请先选择公司地址省市县');
            return false;
        }
        if (!this.formObj.companyDetailAddress) {
            this.$message.error('请先输入公司地址详细地址');
            return false;
        }
        if (this.formObj.mailingRegionCodeArray.length < 1) {
            this.$message.error('请先选择邮寄地址省市县');
            return false;
        }
        if (!this.formObj.mailingDetailAddress) {
            this.$message.error('请先填写邮寄地址详细地址');
            return false;
        }
        if (!this.formObj.contactPerson) {
            this.$message.error('请先填写联系人姓名');
            return false;
        }
        if (!this.formObj.contactPhone) {
            this.$message.error('请先填写联系人电话');
            return false;
        }
        this.newCreatEntrustInfo();
    },
    //保存旧数据
    saveOldData() {
        if (this.changeId == '' || this.changeId == null) {
            this.$message.error('请先勾选数据');
            return false;
        }
        this.changeEntrustInfo();
    },
    newCreatEntrustInfo() {
        let params = {
            "companyDetailAddress": this.formObj.companyDetailAddress,
            "companyName": this.formObj.companyName,
            "companyRegionCodeArray": this.formObj.companyRegionCodeArray,
            "contactPerson": this.formObj.contactPerson,
            "contactPhone": this.formObj.contactPhone,
            "email": this.formObj.email,
            "mailingDetailAddress": this.formObj.mailingDetailAddress,
            "mailingRegionCodeArray": this.formObj.mailingRegionCodeArray,
            "qqNumber": this.formObj.qqNumber,
            "wechatNumber": this.formObj.wechatNumber
        }
        newCreatEntrustInfo(params)
            .then(res => {
                this.$message.success('保存成功');
                this.getEntrustInfoList();
            })
            .catch(error => {
                console.log(error);
            })
    },
    changeEntrustInfo() {
        let params = {
            "id": this.changeId,
            "companyDetailAddress": this.formObj.companyDetailAddress,
            "companyName": this.formObj.companyName,
            "companyRegionCodeArray": this.formObj.companyRegionCodeArray,
            "contactPerson": this.formObj.contactPerson,
            "contactPhone": this.formObj.contactPhone,
            "email": this.formObj.email,
            "mailingDetailAddress": this.formObj.mailingDetailAddress,
            "mailingRegionCodeArray": this.formObj.mailingRegionCodeArray,
            "qqNumber": this.formObj.qqNumber,
            "wechatNumber": this.formObj.wechatNumber
        }
        changeEntrustInfo(params)
            .then(res => {
                this.getEntrustInfoList();
            })
            .catch(error => {
                console.log(error);
            })
    },
    getOneEntrustInfo(data) {
        getOneEntrustInfo(data)
            .then(res => {
                this.formObj.companyName = res.companyName;
                this.formObj.companyDetailAddress = res.companyDetailAddress;
                this.formObj.companyRegionCodeArray = res.companyRegionCodeArray;
                this.formObj.contactPerson = res.contactPerson;
                this.formObj.contactPhone = res.contactPhone;
                this.formObj.email = res.email;
                this.formObj.mailingDetailAddress = res.mailingDetailAddress;
                this.formObj.mailingRegionCodeArray = res.mailingRegionCodeArray;
                this.formObj.qqNumber = res.qqNumber;
                this.formObj.wechatNumber = res.wechatNumber;
            })
            .catch(error => {
                console.log(error);
            })
    },
    getEnterpriseDetail(id) {
        getEnterpriseDetail(id)
            .then(res => {
                if (res.expectTime) {
                    res.expectTime = moment(res.expectTime);
                }
                if (!res.manufacturerName) {
                    res.manufacturerName = undefined;
                }
                this.photoList = res.authTestingAnnex;
                this.formObj = res;
                this.type = res.type;
                setTimeout(() => {
                    this.loading = false;
                }, 500)
            })
            .catch(error => {
                console.log(error);
            })
    },
    getEntrustInfoList() {
        getEntrustInfoList()
            .then(res => {
                this.dataList = res;
            })
            .catch(error => {
                console.log(error);
            })
    },
    submitForm() {
        if (this.type == 1) {
            if (!this.formObj.companyName) {
                this.$message.error('请先填写公司名称');
                return false;
            }
            if (this.formObj.companyRegionCodeArray.length < 1) {
                this.$message.error('请先选择公司地址省市县');
                return false;
            }
            if (!this.formObj.companyDetailAddress) {
                this.$message.error('请先填写公司地址详细地址');
                return false;
            }
            if (this.formObj.mailingRegionCodeArray.length < 1) {
                this.$message.error('请先选择邮寄地址省市县');
                return false;
            }
            if (!this.formObj.mailingDetailAddress) {
                this.$message.error('请先填写邮寄地址详细地址');
                return false;
            }
            if (!this.formObj.contactPerson) {
                this.$message.error('请先填写联系人姓名');
                return false;
            }
            if (!this.formObj.contactPhone) {
                this.$message.error('请先填写联系人电话');
                return false;
            }

            if (!this.formObj.manufacturerName) {
                this.$message.error('请先填写制造商名称');
                return false;
            }
        
            if (!this.formObj.manufacturerAddress) {
                this.$message.error('请先填写制造商地址');
                return false;
            }
        
            if (!this.formObj.factoryName) {
                this.$message.error('请先填写生产商名称');
                return false;
            }
            if (!this.formObj.factoryAddress) {
                this.$message.error('请先填写生产商地址');
                return false;
            }
            // if (!this.formObj.paymentCompany) {
            //     this.$message.error('请先填写缴费单位名称');
            //     return false;
            // }
            if (this.formObj.reportLanguage == '' || this.formObj.reportLanguage == null) {
                this.$message.error('请先选择报告语言');
                return false;
            }
            if (this.formObj.deliveryType == '' || this.formObj.deliveryType == null) {
                this.$message.error('请先选择报告交付方式');
                return false;
            }
            if (!this.formObj.reportNum) {
                this.$message.error('请先填写报告份数');
                return false;
            }
            if (!this.formObj.expectTime) {
                this.$message.error('请先选择希望完成时间');
                return false;
            }
            if (this.formObj.deadlineType == '' || this.formObj.deadlineType == null) {
                this.$message.error('请先选择是否加急');
                return false;
            }
            let testSamples = this.formObj.testSamples;
            if (testSamples.length < 1) {
                this.$message.error('请先添加样品信息');
                return false;
            }
            let flag = true;
            if (testSamples.length > 0) {
                for (let i = 0; i < testSamples.length; i++) {
                    // console.log(testSamples[i])
                    if (!testSamples[i].sampleName || testSamples[i].sampleNum == '' || !testSamples[i].testingRequirements) {
                        this.$message.error('样品信息请填写完整');
                        flag = false;
                        break
                    } else {
                        flag = true;
                    }
                }
            }
            if (!flag) {
                return false;
            }
        } else {
            if (!this.formObj.companyName) {
                this.$message.error('请先填写委托单位名称');
                return false;
            }
            if (this.type == 2 && !this.formObj.applyNumber) {
                this.$message.error('请先填写认证申请编号');
                return false;
            }
            if (this.type == 3 && !this.formObj.orderNumber) {
                this.$message.error('请先填写委托申请编号');
                return false;
            }
            if (!this.formObj.expectTime) {
                this.$message.error('请先选择希望完成时间');
                return false;
            }
            // if (!this.formObj.paymentCompany) {
            //     this.$message.error('请先填写缴费单位名称');
            //     return false;
            // }
        }
        let that = this;
        that.$confirm({
            title: '确定提交订单？提交后工作人员会尽快处理您的订单，请耐心等待！',
            okText: '确定',
            cancelText: '取消',
            onOk:function () {
                submitForm(that.formId)
                    .then(res => {
                        that.needDel = false;
                        that.$message.success('提交成功');
                        that.$bus.$emit('ifReload');
                        setTimeout(() => {
                            that.$router.push({path: '/detection/orderManage'});
                        }, 500)
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
        })
    }
  },
  watch: {
   
  },
};
</script>
<style lang="less" scoped>
    /deep/.ant-modal-close-x {
        width: 30px;
        height: 30px;
        line-height: 30px;
    }
    /deep/.ant-table {
        font-size: 12px;
    }
    .creat-order {
        width: 100%;
        min-height: 100%;
        background-color: #fff;
        padding: 30px 200px;
        margin: 0 auto;
        .select-type {
            margin: 20px 0;
            .type-list {
                display: inline-block;
                margin-right: 20px;
                border: 1px solid #f2f2f2;
                width: 290px;
                padding: 20px;
                border-radius: 10px;
                box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                box-sizing: border-box;
                color: #797979;
                p {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 40px;
                    font-size: 14px;
                    cursor: pointer;
                }
                p:first-child {
                    font-size: 24px;
                    font-weight: 700;
                }
            }
            .active {
                background-color: #007ff2;
                color: #fff;
            }
        }
        .top {
            margin-bottom: 20px;
            .info {
                padding: 20px 10px;
                box-sizing: border-box;
                background-color: #f2f2f2;
                border-left: 6px solid #409eff;
            }

        }
        /deep/.color-bg {
            background-color: #FFF7D0!important;
        }
        .red {
            color: #d11a2d;
        }
        .title {
            .label {
                color: #999;
                font-size: 16px;
            }
            .text {
                font-size: 18px;
                font-weight: 700;
                color: #333;
            }
        }
        .til {
            background-color: #E7F4FF;
            color: #333;
            height: 30px;
            line-height: 30px;
            border-radius: 10px;
            margin: 15px 0;
            padding: 0 30px;
            box-sizing: border-box;
            font-size: 16px;
            // opacity: .7;
        }
        .inline-form {
            display: inline-block;
            margin: 8px 0;
            width: 50%;
            .label {
                display: inline-block;
                width: 120px;
                text-align: right;
            }
            .ant-input-affix-wrapper, .ant-calendar-picker {
                width: 60%;
                min-width: 165px;
            }
            .upload-box {
                display: inline-block;
                .file-list {
                    margin-top: 6px;
                    .file {
                        position: relative;
                        padding: 0 35px 0 5px;
                        max-width: 700px;
                        line-height: 25px;
                        color: #606266;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        transition: all .3s;
                        border-radius: 3px;
                        &:hover {
                            cursor: pointer;
                            background-color: #f5f7fa;
                            .file-name {
                                color: #409eff;
                            }
                        }
                        .file-name {
                            transition: color .3s;
                        }
                        .file-delete-btn {
                            position: absolute;
                            top: 2px;
                            right: 5px;
                            line-height: inherit;
                            &:hover {
                                color: #353535;
                            }
                        }
                    }
                }
            }
        }
        .inline-form_max {
            width: 100%;
            .ant-input-affix-wrapper, textarea {
                width: 80%;
            }
        }
        .form-box {
            .form-list {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 80%;
                margin-bottom: 15px;
                .name {
                    display: block;
                    width: 12%;
                    text-align: right;
                    // background-color: pink;
                    margin-right: 10px;
                }
                .input-box {
                    width: 89%;
                    // background-color: orange;
                    display: flex;
                    justify-content: space-between;
                }
            }
            .btn-area {
                margin: 25px 9%;
            }
            
        }
        .box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            justify-content: space-between;
            p {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                .name {
                    display: block;
                    width: 120px;
                    text-align: right;
                }
                .model {
                    display: block;
                    width: ~"calc(100% - 120px)";
                    color: #999;
                }
            }
            .sample-table {
                width: 100%;
                .sample-list {
                    width: 100%;
                    position: relative;
                    margin-bottom: 10px;
                    .left-box {
                        width: 90%;
                        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.102);
                        padding: 15px;
                        box-sizing: border-box;
                        border-radius: 9px;
                        .list {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            .name {
                                display: block;
                                width: 90px;
                                text-align: right;
                            }
                            .model {
                                display: block;
                                width: ~"calc(100% - 90px)";
                                color: #999;
                            }
                        }
                        .list:last-child {
                            margin-bottom: 0;
                        }
                    }
                    .del-icon {
                        position: absolute;
                        right: 2%;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
            }
            .table {
                width: 100%;
            }
        }
        .ts {
            color: #999;
            font-size: 12px;
        }
        .remark-box {
            display: flex;
            align-items: flex-start;
            .name {
                display: block;
                width: 120px;
                text-align: right;
            }
        }
        .sample-info, .paid-info {
            p {
                width: 50%;
            }
        }
        .report-info {
            justify-content: flex-start;
             p {
                width: 30%;
            }
        }
        .btn-box {
            margin-top: 50px;
            width: 100%;
            text-align: center;
        }
    }
</style>
